import { api } from '../../services/api'

const state = () => ({
  items: [],
  current: null,
  loading: false,
  error: null
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) {
    console.log('[MUTATION] SET_ITEMS:', items)
    state.items = items
  },
  SET_CURRENT(state, item) {
    console.log('[MUTATION] SET_CURRENT:', item)
    state.current = item
  },
  ADD_ITEM(state, item) {
    console.log('[MUTATION] ADD_ITEM:', item)
    state.items.unshift(item)
  },
  UPDATE_ITEM(state, item) {
    console.log('[MUTATION] UPDATE_ITEM:', item)
    const i = state.items.findIndex((x) => String(x.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) {
    console.log('[MUTATION] REMOVE_ITEM:', id)
    state.items = state.items.filter((x) => String(x.id) !== String(id))
  },
  SET_LOADING(state, v) {
    console.log('[MUTATION] SET_LOADING:', v)
    state.loading = v
  },
  SET_ERROR(state, e) {
    console.error('[MUTATION] SET_ERROR:', e)
    state.error = e
  }
}

const actions = {
  async list({ commit }) {
    console.log('[ACTION] list started')
    commit('SET_LOADING', true)

    try {
      console.log('[API] GET admin/accountants')
      const { data } = await api.get('admin/accountants')

      console.log('[API RESPONSE]', data)

      const finalData = Array.isArray(data) ? data : data?.items || []

      console.log('[FINAL DATA]', finalData)

      commit('SET_ITEMS', finalData)
      commit('SET_ERROR', null)

    } catch (e) {
      console.error('[ERROR] list:', e)
      commit('SET_ERROR', e.message || 'Failed to load accountants')
    } finally {
      commit('SET_LOADING', false)
      console.log('[ACTION] list finished')
    }
  },

  async fetchOne({ commit }, id) {
    console.log('[ACTION] fetchOne ID:', id)

    try {
      const { data } = await api.get(`admin/accountants/${id}`)
      console.log('[API RESPONSE fetchOne]', data)

      commit('SET_CURRENT', data)
      return data
    } catch (e) {
      console.error('[ERROR] fetchOne:', e)
    }
  },

  async create({ commit }, payload) {
    console.log('[ACTION] create payload:', payload)

    try {
      const { data } = await api.post('admin/accountants', payload)
      console.log('[API RESPONSE create]', data)

      commit('ADD_ITEM', data)
      return data
    } catch (e) {
      console.error('[ERROR] create:', e)
    }
  },

  async update({ commit }, { id, payload }) {
    console.log('[ACTION] update ID:', id)
    console.log('[ACTION] update payload:', payload)

    try {
      const { data } = await api.put(`admin/accountants/${id}`, payload)
      console.log('[API RESPONSE update]', data)

      commit('UPDATE_ITEM', data)
      return data
    } catch (e) {
      console.error('[ERROR] update:', e)
    }
  },

  async remove({ commit }, id) {
    console.log('[ACTION] remove ID:', id)

    try {
      await api.delete(`admin/accountants/${id}`)
      console.log('[API SUCCESS] deleted:', id)

      commit('REMOVE_ITEM', id)
    } catch (e) {
      console.error('[ERROR] remove:', e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}